import { ReactElement } from "react";
import { t } from "@lingui/core/macro";

import { PermissionTest } from "_/components/permission-test";
import { permissions as rbacPermissions } from "_/data/rbac/definitions";
import { QueueTable } from "_/components/queue/table";
import { useQueueRows } from "_/components/queue/useQueueRows";
import { PrintingTable } from "./printing-table";
import { HistoryTable } from "./history-table";
import { useJobsData } from "./useJobsData";
import * as S from "./styled";

export const JobsView = (): ReactElement | null => {
  const queueProps = useQueueRows();
  const { printingRows, historyRows, isLoading } = useJobsData();

  return (
    <S.PageWrapper>
      <S.Section>
        <S.SectionTitle>{t`components.jobs.printing`}</S.SectionTitle>
        <PrintingTable rows={printingRows} loading={isLoading} />
      </S.Section>

      <PermissionTest requiredPermissions={rbacPermissions.queue.read}>
        <S.Section>
          <S.SectionTitle>{t`components.jobs.queue`}</S.SectionTitle>
          <QueueTable
            {...queueProps}
            loading={queueProps.isLoading}
            showActions
            showDrag={queueProps.canEdit}
            noDataLabel={t`components.queue.empty`}
          />
        </S.Section>
      </PermissionTest>

      <S.Section>
        <S.SectionTitle>{t`components.jobs.history`}</S.SectionTitle>
        <HistoryTable rows={historyRows} loading={isLoading} />
      </S.Section>
    </S.PageWrapper>
  );
};
